import { render } from "./ViewReviewPost.vue?vue&type=template&id=7392cc11"
import script from "./ViewReviewPost.vue?vue&type=script&lang=js"
export * from "./ViewReviewPost.vue?vue&type=script&lang=js"

import "./ViewReviewPost.vue?vue&type=style&index=0&id=7392cc11&lang=css"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__